import { Component, OnInit, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DidProvider } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-select-provider',
  templateUrl: './select-provider.component.html',
  styleUrls: ['./select-provider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectProviderComponent),
      multi: true
    }
  ]
})
export class SelectProviderComponent implements OnInit, ControlValueAccessor {
  value: any;
  onChange: (value: any) => void;
  onTouched: () => void;
  disabled: boolean;
  @Input() providers: DidProvider[] = [];

  constructor() { }

  ngOnInit(): void {}

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  selectProvider(provider: DidProvider) {
    this.onChange(provider);
    this.value = provider;
  }

}
